export const config = {
  cookieName: "Phyzzi_locale",
  dismissalDays: 365
};
